import createRoute     from '@widesk-ui/tools/createRoute';
import ProductSetModel from '@models/shop/ProductSetModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/product_sets', 'shop', 'ProductSetDashboard', ProductSetModel.localize());
